module.exports = __webpack_public_path__ + "media/images/visual-schedule-login-528f682b55c7db9695983627d0f9e5c8.jpg";